import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const kubernetesService = {
  getList:(queries:QueriesApi) => ApiClient.get('clusters', {
    params:{
      page_size:queries.pageSize,
      page:queries.page,
    }
  }),
  checkName:(name:string) => ApiClient.post('clusters/check_name', {name}),
  editRestriction:(clusterId:string, data:Object) => ApiClient.patch(`clusters/${clusterId}`, data),
  deleteNodePool:(id:string, clusterId:string) => ApiClient.delete(`cluster/node-pools/${id}`, {
    params:{ cluster_id: clusterId }
  }),
  createNodePool:(data:Object) => ApiClient.post(`cluster/node-pools`, data),
  editNodePool:(id:string, data:Object, clusterId:string) => ApiClient.patch(`cluster/node-pools/${id}`, data, {
    params:{ cluster_id: clusterId }
  }),
  createCluster:(data:any) => ApiClient.post('clusters', data),
  getVersions:() => ApiClient.get('clusters/versions'),
  getNetworks:() => ApiClient.get('clusters/networking'),
  deleteCluster:(id:string) => ApiClient.delete(`clusters/${id}`),
  getClusterById:(id:string) => ApiClient.get(`clusters/${id}`),
  upgradeCluster:(id:string, data:Object) => ApiClient.patch(`clusters/${id}`, data),
  getAddons:() => ApiClient.get(`clusters/addons`),
  installAddon:(id:string|number, data:{release_ids:number[]}) => ApiClient.post(`clusters/${id}/install_addons`, data),
  downloadConfig:(id:string) => ApiClient.get(`clusters/${id}/download_config`),
}

export default kubernetesService